import React from 'react';

import { IIconProps, TIconType } from '../interface';

const DownloadFileIcon: TIconType = (props?: IIconProps) => {
	return props?.isActive
		? (
			<svg
				data-testid='file-download-icon'
				fill='none'
				height='20'
				viewBox='0 0 20 20'
				width='20'
			>
				<g
					clipPath='url(#clip0_18145_309653)'
				>
					<rect
						fill='#2E2E6B'
						height='20'
						rx='10'
						width='20'
					/>
					<path
						d='M13.2434 9.51477L10.1797 12.5785L7.11594 9.51477'
						stroke='white'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
					<path
						d='M10.1797 4L10.1797 12.5785'
						stroke='white'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
					<path
						d='M15 15L5 15'
						stroke='white'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
				</g>
				<defs>
					<clipPath
						id='clip0_18145_309653'
					>
						<rect
							fill='white'
							height='20'
							rx='10'
							width='20'
						/>
					</clipPath>
				</defs>
			</svg>
		)
		: (
			<svg
				data-testid='file-download-icon'
				fill='none'
				height='20'
				viewBox='0 0 20 20'
				width='20'
			>
				<g
					clipPath='url(#clip0_18145_309679)'
				>
					<rect
						fill='#2E2E6B'
						fillOpacity='0.1'
						height='20'
						rx='10'
						width='20'
					/>
					<path
						d='M12.9136 9.29419L9.97239 12.2354L7.0312 9.29419'
						stroke='#2E2E6B'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
					<path
						d='M9.97241 4L9.97241 12.2353'
						stroke='#2E2E6B'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
					<path
						d='M15 15L5 15'
						stroke='#2E2E6B'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
				</g>
				<defs>
					<clipPath id='clip0_18145_309679'>
						<rect
							fill='white'
							height='20'
							rx='10'
							width='20'
						/>
					</clipPath>
				</defs>
			</svg>
		);
};

export default DownloadFileIcon;
